import React from 'react';

const Michigan = () => {
  return (
    <div>
      <h2 className="text-xl font-bold uppercase mt-8 mb-2 border-b pb-1">
        Michigan Specific Terms
      </h2>
      <ol className="text-black mb-4 text-base list-decimal list-inside">
        <li>
          Disclosure form required detailing physical condition of the
          property..
        </li>
        <li>Seller’s Disclosure Statement: Required for residential sales.</li>
        <li>
          <span
            className="underline text-blue-500 hover:text-blue-700 cursor-pointer"
            onClick={() => {
              window.open(
                'https://eforms.com/images/2015/09/sellers-disclosure-of-lead-paint.pdf',
                '_blank'
              );
            }}
          >
            Lead-Based Paint Disclosure{' '}
          </span>{' '}
          – Only for residences that were built before 1978. This information
          should be available at the County’s Revenue Office.
        </li>
        <li>
          <span
            className="underline text-blue-500 hover:text-blue-700 cursor-pointer"
            onClick={() => {
              window.open(
                'https://eforms.com/images/2018/07/Michigan-Sellers-Disclosure-Statement.pdf',
                '_blank'
              );
            }}
          >
            Seller's Property Disclosure Statement{' '}
          </span>{' '}
          – Sellers must provide a comprehensive disclosure of the property's
          condition and advise the buyer to conduct a professional inspection.
        </li>
      </ol>
    </div>
  );
};

export default Michigan;
